import intl from 'react-intl-universal';
import AppDispatcher from '../dispatcher/AppDispatcher';
import PackConstants from '../constants/PackConstants';
import Popup from 'react-popup';
import { EventEmitter } from 'events';

const CHANGE_EVENT = 'change';

let _variants = false;
let _pack = false;
let _pack_important = false;
let _is_multi = false;
let _order = false;
let _done = false;
let _scanned_code = false

function setVariants(variants) {
  _variants = variants
}

function setPack(pack, from_search) {
  if(from_search && !pack){
    Popup.alert(intl.get('Wskazany wózek nie ma przypisanego pakietu'))
    pack = {'id': false, 'is_multi': false, 'important': false}
  }
  _pack = pack.id
  _pack_important = pack.important
  _is_multi = pack.is_multi
}

function setOrder(order) {
  _order = order;
}

function setDone(done) {
  _done = done;
}

function setScannedCode(scanned_code) {
  _scanned_code = scanned_code;
}

class StateStoreClass extends EventEmitter {

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback)
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback)
  }

  getVariants() {
    return _variants
  }

  getPack() {
    return _pack
  }

  getPackImportant() {
    return _pack_important
  }

  getIsMulti() {
    return _is_multi
  }

  getOrder(){
    return _order
  }

  getDone(){
    return _done
  }

  getScannedCode(){
    return _scanned_code
  }

}

const StateStore = new StateStoreClass();

// Here we register a callback for the dispatcher
// and look for our various action types so we can
// respond appropriately
StateStore.dispatchToken = AppDispatcher.register(action => {

  switch(action.actionType) {

    case PackConstants.RECIEVE_VARIANTS:
      setVariants(action.variants)
      StateStore.emitChange()
      break

    case PackConstants.RECIEVE_VARIANTS_ERROR:
      Popup.alert(action.message)
      StateStore.emitChange()
      break

    case PackConstants.SELECT_PACK:
      setPack(action.pack, action.from_search)
      StateStore.emitChange()
      break

    case PackConstants.SELECT_VARIANT:
      setVariants({[action.code]: ''})
      StateStore.emitChange()
      break

    case PackConstants.DESELECT_ORDER:
      setVariants(false)
      setOrder(false)
      StateStore.emitChange()
      break

    case PackConstants.RECIEVE_ORDER:
      setOrder(action.order)
      StateStore.emitChange()
      break

    case PackConstants.RECIEVE_ORDER_ERROR:
      setVariants(false)
      setOrder(false)
      Popup.alert(action.message)
      StateStore.emitChange()
      break

    case PackConstants.PROCESS_PAKOWANIE:
      setDone(action.result)
      StateStore.emitChange()
      break

    case PackConstants.PROCESS_PAKOWANIE_ERROR:
      Popup.create({
        content: action.message,
        buttons: {
          right: [{
            text: 'Ok',
            key: 'enter',
            action: function () {
              Popup.close()
              setVariants(false)
              setOrder(false)
              StateStore.emitChange()
            }
          }]
        }
      })
      break

    case PackConstants.PRINT_INVOICE:
      Popup.alert(intl.get('Faktura została wysłana do druku'))
      setDone(false)
      setVariants(false)
      setOrder(false)
      StateStore.emitChange()
      break

    case PackConstants.PRINT_INVOICE_ERROR:
      Popup.alert('Wystąpił błąd podczas drukowania faktury!\n\n' + action.message)
      break

    case PackConstants.GET_CART_ERROR:
      Popup.alert(action.message)
      document.querySelector('input[type="submit"]').disabled = false
      break

    case PackConstants.SCAN_PRODUCT:
      setScannedCode(action.code)
      StateStore.emitChange()
      break

    case PackConstants.SCAN_PRODUCT_DONE:
      setScannedCode(false)
      StateStore.emitChange()

    case PackConstants.CONFIRM_DONE:
      setDone(false)
      setVariants(false)
      setOrder(false)
      StateStore.emitChange()
    default:
  }

});

export default StateStore;



// WEBPACK FOOTER //
// ./src/stores/StateStore.js